import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {Text} from '../../../../component/text/text';
import {Locale} from '../../../../provider/locale/locale';
import {HelpLinkFeatureFlagEnum} from '../../../../service/feature-flags/feature-flag-const';
import {useFeatureFlag} from '../../../../service/feature-flags/use-feature-flag';
import {classNames} from '../../../../util/css';

import {
    CALENDAR_LEGEND_STATUS_LIST,
    CALENDAR_LEGEND_TYPE_LIST,
    ICON_BY_CALENDAR_PUBLICATION_TYPE,
    STATUS_MODIFIER_BY_CALENDAR_POST_STATUS,
    TEXT_BY_CALENDAR_POST_STATUS,
    TEXT_BY_CALENDAR_PUBLICATION_TYPE,
} from './posts-calendar-const';
import * as styles from './posts-calendar.scss';

export function PostsCalendarLegend(): JSX.Element {
    // With the publication-catalog rollout off only Posts reach the calendar, so a legend listing
    // Promotions and Events would describe icons that never appear.
    const isPublicationCatalogEnabled = useFeatureFlag(HelpLinkFeatureFlagEnum.publicationCatalog);

    return (
        <div className={styles.PostCalendar_legend}>
            <div className={styles.PostCalendar_legendGroup}>
                <Text bolder small stringKey="POSTS__CALENDAR_LEGEND__STATUS_TITLE" />

                {CALENDAR_LEGEND_STATUS_LIST.map((status) => (
                    <span className={styles.PostCalendar_legendItem} key={status}>
                        <span
                            className={classNames(
                                styles.PostCalendar_dot,
                                STATUS_MODIFIER_BY_CALENDAR_POST_STATUS[status]
                            )}
                        />

                        <Locale stringKey={TEXT_BY_CALENDAR_POST_STATUS[status]} />
                    </span>
                ))}
            </div>

            {isPublicationCatalogEnabled && (
                <div className={styles.PostCalendar_legendGroup}>
                    <Text bolder small stringKey="POSTS__CALENDAR_LEGEND__TYPE_TITLE" />

                    {CALENDAR_LEGEND_TYPE_LIST.map((type) => (
                        <span className={styles.PostCalendar_legendItem} key={type}>
                            <FontAwesomeIcon
                                className={styles.PostCalendar_legendTypeIcon}
                                icon={ICON_BY_CALENDAR_PUBLICATION_TYPE[type]}
                            />

                            <Locale stringKey={TEXT_BY_CALENDAR_PUBLICATION_TYPE[type]} />
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
}
